export default __webpack_public_path__ + "static/media/Grizzly Breeches.54704d3d.jpg";